import { Invite } from '../types';

export function createInvite(
	payload: Pick<
		Invite,
		| 'organization'
		| 'user'
		| 'authUser'
		| 'createdBy'
		| 'email'
		| 'createdAt'
		| 'expiresAt'
		| 'message'
	>,
) {
	return {
		id: '', // replaced after the creation
		...payload,
		updatedAt: payload.createdAt,
		deletedAt: null,
	};
}

export function getInviteUrl(inviteId: string, userId: string, email: string) {
	return `invite?id=${inviteId}&user=${userId}&email=${encodeURIComponent(email)}`;
}
